import { ReactNode } from "react";
import * as React from "react";
import {
  Wrapper,
  AddonAfter,
  DisabledTip,
  MainContainer,
  ExtraContainer,
  AddonBefore,
  CompanyButton,
} from "./styled";
import "./index.css";
import cs from "classnames";
import { Tooltip } from "@bit-design/react";
export interface PlainInputProps {
  addonBefore?: ReactNode;
  addonAfter?: ReactNode;
  addonExtra?: ReactNode;
  disabled?: boolean;
  disabledText?: ReactNode;
  tooltip?: ReactNode;
  placeholder?: string;
  value: string;
  onChange: (newValue: string) => void;
  slim?: boolean;
  onFocus?: () => void;
  onBlur?: () => void;
  autoFocus?: boolean;
  style?: object;
  force?: boolean; // 是否可强制唤醒
  onActive?: () => void; // 被强制唤醒是的动作
  size?: string | number;
  className?: string;
  formatter?: (newValue: string, oldValue: string) => string;
  afferIcon?: ReactNode;
  precision?: number;
}

interface State {
  focusing: boolean;
  value: any;
  visible: boolean;
}

const SpecialInputButton: React.FC<any> = (props) => {
  const { children, ...rest } = props;
  return <CompanyButton {...rest}>{children}</CompanyButton>;
};

class PlainInput extends React.Component<PlainInputProps, State> {
  static defaultProps = {
    force: false,
    tooltip: "",
  };
  static Button = SpecialInputButton;

  input: HTMLInputElement;
  wrapperRef: HTMLElement;
  constructor(props: PlainInputProps) {
    super(props);
    const { value } = props;
    this.state = {
      focusing: false,
      value,
      visible: false,
    };
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  /**
   * 自动让value与props同步
   * @param nextProps
   */
  static getDerivedStateFromProps(nextProps: PlainInputProps) {
    // 根据tooltip给定的值，自动显示或关闭tooltip
    if ("value" in nextProps || "tooltip" in nextProps) {
      return {
        value: nextProps.value,
      };
    }
    return null;
  }

  /**
   * 保存整个输入组件的ref
   * @param node
   */
  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  /**
   * 再点击外部时再移除聚焦
   */
  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.handleBlur();
    }
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  saveInput = (input: HTMLInputElement) => {
    this.input = input;
  };

  handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value;
    const { onChange, formatter, precision } = this.props;
    if (onChange) {
      if (formatter) {
        value = formatter(value, this.state.value);
      }
      //小数位超过精度不给输入
      if (precision && value.split(".")[1]?.length > precision) {
        return;
      }
      onChange(value);
    }
  };

  handleFocus = () => {
    this.setState({ focusing: true });
    this.props.onFocus?.();
    this.input?.focus();
    if (this.props.tooltip) {
      this.setState({ visible: true });
    }
  };

  handleBlur = () => {
    this.setState({ focusing: false, visible: false });
    this.props.onBlur?.();
  };

  handlerClick = () => {
    if (this.props.disabled) {
      // 禁用状态下，仅在可强制激活时可用
      this.handleActive();
    } else {
      this.handleFocus();
    }
  };

  handleActive = () => {
    if (this.props.force) {
      this.props.onActive?.();
      // 切换状态后确保输入框的自动聚焦
      setTimeout(() => {
        this.handleFocus();
      }, 40);
    }
  };
  render() {
    const { value, focusing, visible } = this.state;
    const {
      addonBefore,
      addonAfter,
      disabledText,
      placeholder,
      autoFocus,
      disabled,
      addonExtra,
      tooltip,
      slim,
      afferIcon,
      className,
    } = this.props;
    return (
      <Wrapper
        className={cs("special-input", className, { focusing, disabled, slim })}
        ref={this.setWrapperRef}
        onClick={this.handlerClick}
      >
        <Tooltip placement="top" title={tooltip} visible={visible}>
          <MainContainer
            className={cs({
              focusing: (focusing || value?.length > 0) && !disabled,
              disabled,
              slim,
            })}
          >
            {disabled ? (
              <>
                <DisabledTip>{disabledText}</DisabledTip>
                {addonAfter && <AddonAfter>{addonAfter}</AddonAfter>}
              </>
            ) : (
              <>
                {addonBefore && <AddonBefore>{addonBefore}</AddonBefore>}
                <input type="password" style={{ display: "none" }} />
                <input
                  type="text"
                  autoFocus={autoFocus}
                  placeholder={placeholder}
                  value={value}
                  onChange={this.handleChange}
                  ref={this.saveInput}
                />
                {afferIcon}
                {addonAfter && <AddonAfter>{addonAfter}</AddonAfter>}
              </>
            )}
          </MainContainer>
        </Tooltip>
        {addonExtra ? (
          <ExtraContainer
            className={cs({ disabled })}
            onClick={(e) => e.stopPropagation()}
          >
            {addonExtra}
          </ExtraContainer>
        ) : null}
      </Wrapper>
    );
  }
}

export default PlainInput;
